import ApiClient from "../api";

import { processResponse, processError } from "../api/utils/api";
import Support from "../types/Support";
import { APP_ERROR } from "../types/App";

export const fetchAllSupportDataReceive = ({
  categories,
  sections,
  articles,
}) => ({
  type: Support.FETCH_ALL_SUPPORT_DATA_RECEIVE,
  categories,
  sections,
  articles,
});

export const fetchAllSupportDataFailure = (errors) => {
  return (dispatch) => {
    dispatch({ type: APP_ERROR, errors });
    dispatch({ type: Support.FETCH_ALL_SUPPORT_DATA_FAILURE, errors });
  };
};

export const fetchAllSupportDataRequest = () => {
  return (dispatch) => {
    const { fetchAllCategories, fetchAllSections, fetchAllArticles } =
      ApiClient.getZendesk();

    dispatch({ type: Support.FETCH_ALL_SUPPORT_DATA_REQUEST });

    return Promise.all([
      fetchAllCategories(),
      fetchAllSections(),
      fetchAllArticles(),
    ])
      .then(([categoriesResp, sectionsResp, articlesResp]) => {
        const res = {
          ok: categoriesResp.ok && sectionsResp.ok && articlesResp.ok,
          data: {
            categories: categoriesResp.data,
            sections: sectionsResp.data,
            articles: articlesResp.data,
          },
          originalError: [
            categoriesResp.originalError,
            sectionsResp.originalError,
            articlesResp.originalError,
          ],
        };

        return dispatch(
          processResponse(
            res,
            fetchAllSupportDataReceive,
            fetchAllSupportDataFailure
          )
        );
      })
      .catch((err) => dispatch(processError(err, fetchAllSupportDataFailure)));
  };
};

export const fetchSupportSectionDetailReceive = ({ section }) => {
  return {
    type: Support.FETCH_SUPPORT_SECTION_DETAIL_RECEIVE,
    section,
  };
};

export const fetchSupportSectionDetailFailure = (errors) => {
  return (dispatch) => {
    dispatch({ type: APP_ERROR, errors });
    dispatch({ type: Support.FETCH_SUPPORT_SECTION_DETAIL_FAILURE, errors });
  };
};

export const fetchSupportSectionDetailRequest = (sectionId) => {
  return (dispatch) => {
    dispatch({ type: Support.FETCH_SUPPORT_SECTION_DETAIL_REQUEST });
    return ApiClient.getZendesk()
      .fetchSectionDetail(sectionId)
      .then((res) =>
        dispatch(
          processResponse(
            res,
            fetchSupportSectionDetailReceive,
            fetchSupportSectionDetailFailure
          )
        )
      )
      .catch((err) =>
        dispatch(processError(err, fetchSupportSectionDetailFailure))
      );
  };
};

export const fetchSupportArticleDetailReceive = ({ article }) => {
  return {
    type: Support.FETCH_SUPPORT_ARTICLE_DETAIL_RECEIVE,
    article,
  };
};

export const fetchSupportArticleDetailFailure = (errors) => {
  return (dispatch) => {
    dispatch({ type: APP_ERROR, errors });
    dispatch({ type: Support.FETCH_SUPPORT_ARTICLE_DETAIL_FAILURE, errors });
  };
};

export const fetchSupportArticleDetailRequest = (articleId) => {
  return (dispatch) => {
    dispatch({ type: Support.FETCH_SUPPORT_ARTICLE_DETAIL_REQUEST });
    return ApiClient.getZendesk()
      .fetchArticleDetail(articleId)
      .then((res) =>
        dispatch(
          processResponse(
            res,
            fetchSupportArticleDetailReceive,
            fetchSupportArticleDetailFailure
          )
        )
      )
      .catch((err) =>
        dispatch(processError(err, fetchSupportArticleDetailFailure))
      );
  };
};

export const searchSupportArticlesReceive = (results) => ({
  type: Support.NEW_SEARCH_SUPPORT_ARTICLES_RECEIVE,
  results,
});

export const searchSupportArticlesFailure = (errors) => {
  return (dispatch) => {
    dispatch({ type: APP_ERROR, errors });
    dispatch({ type: Support.NEW_SEARCH_SUPPORT_ARTICLES_FAILURE, errors });
  };
};

export const searchSupportArticlesRequest = (query, pageNum = 1) => {
  return (dispatch) => {
    dispatch({ type: Support.NEW_SEARCH_SUPPORT_ARTICLES_REQUEST, pageNum });
    return ApiClient.getZendesk()
      .search(query, pageNum)
      .then((res) =>
        dispatch(
          processResponse(
            res,
            searchSupportArticlesReceive,
            searchSupportArticlesFailure
          )
        )
      )
      .catch((err) =>
        dispatch(processError(err, searchSupportArticlesFailure))
      );
  };
};

export const storeSupportSearchQuery = (query) => ({
  type: Support.STORE_SUPPORT_SEARCH_QUERY,
  query,
});

export const resetSectionDetailData = () => ({
  type: Support.RESET_SECTION_DETAIL_DATA,
});

export const resetArticleDetailData = () => ({
  type: Support.RESET_ARTICLE_DETAIL_DATA,
});
